import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { MeasureService } from '../measure.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalShareInformantComponent } from '../modal-share-informant/modal-share-informant.component';
import { of } from 'rxjs';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ModalInformantComponent } from '../modal-informant/modal-informant.component';
import { ProfileService } from '../../profile/profile.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
  selector: 'app-measure-detail',
  templateUrl: './measure-detail.component.html',
  styleUrls: ['./measure-detail.component.scss']
})
export class MeasureDetailComponent implements OnInit {
  isHidden: boolean = false;
  link: string;
  measure;
  suggestCourse = [];
  accessLink: string;
  measureDetail;

  // params
  participant: number; // form mail --> don't show modal invite informant
  participant_from: string = '' // form mail
  isMultiInformant: number = 0; // form click in measure page --> show modal invite informant

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    margin: 15,
    autoplay: false,
    dots: true,
    navSpeed: 700,
    nav: false,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      760: {
        items: 3
      },
      1000: {
        items: 4
      }
    }
  }

  userEmail: string;
  token: string = '';

  constructor(
    private route: ActivatedRoute,
    private measureService: MeasureService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private gobalFunctionService: GobalFunctionService,
    public matDialog: MatDialog,
    private profileService: ProfileService,
    private authService: AuthService,
  ) {
    this.token = authService.getToken();
  }

  ngOnInit(): void {
    this.participant = JSON.parse(new URL(location.href).searchParams.get('participant')); // from email
    this.participant_from = new URL(location.href).searchParams.get('participant_from'); // from email
    this.isMultiInformant = JSON.parse(new URL(location.href).searchParams.get('IS_MULTI_INFORMANT')); // from click

    console.log(this.token);

    if (!this.participant_from) {
      this.getNormalMeasure();
    } else {
      if (this.token) {
        this.getInformantMeasure();
      } else {
        this.openLogin();
      }
    }

    if(this.token) {
      this.getProfile();
    }
  }

  getProfile() {
    this.profileService.getProfile().pipe(
      map(email => {
        if (email.success) {
          this.userEmail = email.result.EMAIL;
        }
      })
    ).subscribe();
  }

  getNormalMeasure() {
    this.route.params.pipe(
      switchMap(params => {
        this.link = params['link'];
        return this.measureService.getNormalMeasureByLink(params['link']);
      }),
      map(res => {
        // console.log(res.result[0]);
        this.measure = res.result[0];
        this.accessLink = this.measure.LINK;
        let currentDate = new Date();
        let endDate = new Date(this.measure.MEASURE_END);
        this.measureDetail = this.sanitizer.bypassSecurityTrustHtml(this.measure.DESCRIPTION);
        this.gobalFunctionService.setSEO(res.result[0].MEASURE_NAME, 'website', '');

        // check measure time out
        if (endDate < currentDate && this.measure.ALWAYS_OPEN === 'false') {
          this.isHidden = true;
          alert('แบบทดสอบนี้ไม่ได้อยู่ในช่วงเปิดให้ทำแบบทดสอบ');
          window.open(window.location.origin + '/measure', '_self', '');
        }
        this.suggestCourse = this.measure.SUGGESTION_COURSE;
      })
    ).subscribe()
  }

  getInformantMeasure() {
    this.route.params.pipe(
      switchMap(params => {
        this.link = params['link'];
        return this.measureService.getInformantMeasureByLink(params['link'], this.participant_from, true);
      }),
      map(res => {
        // console.log(res.result[0]);
        this.measure = res.result[0];
        this.accessLink = this.measure.LINK;
        let currentDate = new Date();
        let endDate = new Date(this.measure.MEASURE_END);
        this.measureDetail = this.sanitizer.bypassSecurityTrustHtml(this.measure.DESCRIPTION);
        this.gobalFunctionService.setSEO(res.result[0].MEASURE_NAME, 'website', '');

        // check measure time out
        if (endDate < currentDate && this.measure.ALWAYS_OPEN === 'false') {
          this.isHidden = true;
          alert('แบบทดสอบนี้ไม่ได้อยู่ในช่วงเปิดให้ทำแบบทดสอบ');
          window.open(window.location.origin + '/measure', '_self', '');
        }
        this.suggestCourse = this.measure.SUGGESTION_COURSE;
      }),
      catchError(err => {
        alert(err.error.message);
        this.router.navigate(['/measure']);
        return of(false);
      })
    ).subscribe()
  }

  viewCourse(courseId) {
    window.open('e-learning/' + courseId, '_blank');
  }

  startMeasure() {
    this.router.navigate(
      ['/measure/measure-start'],
      { relativeTo: this.route, });
  }

  startMeasureByInformant() {
    let queryParams: Params;

    if (this.isMultiInformant === 1) {
      queryParams = {
        IS_MULTI_INFORMANT: 1
      }
    } else {
      queryParams = {
        participant: this.participant,
        participant_from: this.participant_from,
      }
    }

    this.router.navigate(
      ['/measure/measure-start'],
      {
        relativeTo: this.route,
        queryParams: queryParams
      }
    );
  }

  colloectAccessLink() {
    if (this.measure.TIME_MEASURE_AGAIN === true) {
      this.measureService.colAccessLink(this.accessLink);

      if (this.isMultiInformant === 1) {
        this.inviteInformant();
      } else {
        if (this.participant && this.participant_from) {
          console.log('tg');
          this.startMeasureByInformant();
        } else {
          console.log('wrong');
          this.startMeasure();
        }
      }

    } else if (this.measure.TIME_MEASURE_AGAIN !== true) {
      let date = this.measure.TIME_MEASURE_AGAIN;
      let d = new Date(date);
      alert(`คุณสามารถทำแบบทดสอบได้อีกในวันที่ ${new DatePipe().transform(d.toString(), 'full')}`);
      window.close();
    }
  }

  inviteInformant() {

    this.measureService.getParticipantByMeasure(this.measure.MEASURE_ID).pipe(
      switchMap(par => {
        let isInvite: boolean = true;
        for (let i = 0; i < par.result.length; i++) {
          let el = par.result[i];
          if (el.EMAIL) {
            isInvite = false;
            break;
          }
        }

        if (isInvite) {
          const dialogInformantConfig = new MatDialogConfig();
          dialogInformantConfig.disableClose = true;
          dialogInformantConfig.id = 'modalInformantMeasure';
          dialogInformantConfig.width = '650px';
          dialogInformantConfig.autoFocus = false;
          dialogInformantConfig.panelClass = 'full-width-dialog';
          dialogInformantConfig.data = {
            MEASURE_ID: this.measure.MEASURE_ID,
            userEmail: this.userEmail,
          }
          const informantModal = this.matDialog.open(ModalShareInformantComponent, dialogInformantConfig);
          return informantModal.afterClosed().pipe(
            switchMap(invite => {
              if (invite.status) {
                console.log(invite.body);
                return this.measureService.inviteInformantMeasure(invite.body).pipe(
                  switchMap(res => {
                    if (res.success) {

                      const successDialogConfig = new MatDialogConfig();
                      successDialogConfig.disableClose = true;
                      successDialogConfig.id = 'modalConfirm';
                      successDialogConfig.width = '350px';
                      successDialogConfig.data = {
                        title: 'ผู้ที่มีส่วนร่วมในการทำแบบทดสอบ',
                        description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                        <h5>ส่งคำเชิญสำเร็จ</h5><br>
                        <h5>เริ่มทำแบบทดสอบ</h5>`,
                        cancleBtnText: 'ยืนยัน',
                        customStyle: 'background-color: #58595B;'
                      }

                      const modal = this.matDialog.open(ModalComponent, successDialogConfig);
                      return modal.afterClosed().pipe(
                        map(res => {
                          if (!res) {
                            this.startMeasureByInformant();
                          }
                        })
                      )
                    } else {
                      return of(false);
                    }
                  })
                )
              } else {
                return of(null);
              }
            })
          )
        } else {
          const dialogInformantConfig = new MatDialogConfig();
          dialogInformantConfig.disableClose = true;
          dialogInformantConfig.id = 'modalInformantMeasure';
          dialogInformantConfig.width = '650px';
          dialogInformantConfig.autoFocus = false;
          dialogInformantConfig.panelClass = 'full-width-dialog';
          dialogInformantConfig.data = {
            MEASURE_ID: this.measure.MEASURE_ID,
            isTake: true,
            userEmail: this.userEmail,
          }
          const informantModal = this.matDialog.open(ModalInformantComponent, dialogInformantConfig);
          return informantModal.afterClosed().pipe(
            switchMap(res => {
              if (res.status) {
                if (res.type === 'take') {
                  this.startMeasureByInformant();
                  return of(null);
                } else {
                  return this.measureService.inviteInformantMeasure(res.body).pipe(
                    switchMap(res => {
                      if (res.success) {

                        const successDialogConfig = new MatDialogConfig();
                        successDialogConfig.disableClose = true;
                        successDialogConfig.id = 'modalConfirm';
                        successDialogConfig.width = '350px';
                        successDialogConfig.data = {
                          title: 'ผู้ที่มีส่วนร่วมในการทำแบบทดสอบ',
                          description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                          <h5>ส่งคำเชิญสำเร็จ</h5><br>
                          <h5>เริ่มทำแบบทดสอบ</h5>`,
                          cancleBtnText: 'ยืนยัน',
                          customStyle: 'background-color: #58595B;'
                        }

                        const modal = this.matDialog.open(ModalComponent, successDialogConfig);
                        return modal.afterClosed().pipe(
                          map(res => {
                            if (!res) {
                              this.startMeasureByInformant();
                            }
                          })
                        )
                      } else {
                        return of(false);
                      }
                    })
                  )
                }
              } else {
                return of(null);
              }
            })
          )
        }
      }),
      catchError((err) => {
        alert('ระบบขัดข้องกรุณาลองใหม่อีกครั้ง');
        return of(false);
      })
    ).subscribe();

  }

  openLogin() {
    this.router.navigate(['login'], { state: { redirect: this.router.url } })
  }

  close() {
    window.close();
  }
}
